import types from "./types";

const INITIAL_STATE = {
	equipment_evaluation: null,
	equipment_evaluationError: null,
	equipment_evaluationLoading: false,

	//create
	createequipment_evaluation: null,
	createequipment_evaluationError: null,
	createequipment_evaluationLoading: false,

	//update
	updateequipment_evaluation: null,
	updateequipment_evaluationError: null,
	updateequipment_evaluationLoading: false,

	//delete
	deleteequipment_evaluation: null,
	deleteequipment_evaluationError: null,
	deleteequipment_evaluationLoading: false,

	//single item

	singleItem: null,
};

const EquipmentEvaluationReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case types.GET_EQUIPMENT_EVALUATION_START:
			return {
				...state,
				equipment_evaluation: null,
				equipment_evaluationError: null,
				equipment_evaluationLoading: true,
			};
		case types.GET_EQUIPMENT_EVALUATION_SUCCESS:
			return {
				...state,
				equipment_evaluation: action.payload,
				equipment_evaluationLoading: false,
			};
		case types.GET_EQUIPMENT_EVALUATION_ERROR:
			return {
				...state,
				equipment_evaluationError: action.payload,
				equipment_evaluationLoading: false,
			};
		case types.GET_EQUIPMENT_EVALUATION_RESET:
			return {
				...state,
				equipment_evaluationError: null,
				equipment_evaluationLoading: false,
			};
		//create

		case types.CREATE_EQUIPMENT_EVALUATION_START:
			return {
				...state,
				createequipment_evaluation: null,
				createequipment_evaluationError: null,
				createequipment_evaluationLoading: true,
			};
		case types.CREATE_EQUIPMENT_EVALUATION_SUCCESS:
			return {
				...state,
				createequipment_evaluation: action.payload,
				createequipment_evaluationLoading: false,
			};
		case types.CREATE_EQUIPMENT_EVALUATION_ERROR:
			return {
				...state,
				createequipment_evaluationError: action.payload,
				createequipment_evaluationLoading: false,
			};
		case types.CREATE_EQUIPMENT_EVALUATION_RESET:
			return {
				...state,
				createequipment_evaluationError: null,
				createequipment_evaluationLoading: false,
			};
		//delete

		case types.DELETE_EQUIPMENT_EVALUATION_START:
			return {
				...state,
				deleteequipment_evaluation: null,
				deleteequipment_evaluationError: null,
				deleteequipment_evaluationLoading: true,
			};
		case types.DELETE_EQUIPMENT_EVALUATION_SUCCESS:
			return {
				...state,
				deleteequipment_evaluation: action.payload,
				deleteequipment_evaluationLoading: false,
			};
		case types.DELETE_EQUIPMENT_EVALUATION_ERROR:
			return {
				...state,
				deleteequipment_evaluationError: action.payload,
				deleteequipment_evaluationLoading: false,
			};
		case types.DELETE_EQUIPMENT_EVALUATION_RESET:
			return {
				...state,
				deleteequipment_evaluation: null,
				deleteequipment_evaluationError: null,
				deleteequipment_evaluationLoading: false,
			};

		//update
		case types.UPDATE_EQUIPMENT_EVALUATION_START:
			return {
				...state,
				updateequipment_evaluation: null,
				updateequipment_evaluationError: null,
				updateequipment_evaluationLoading: true,
			};
		case types.UPDATE_EQUIPMENT_EVALUATION_SUCCESS:
			return {
				...state,
				updateequipment_evaluation: action.payload,
				updateequipment_evaluationLoading: false,
			};
		case types.UPDATE_EQUIPMENT_EVALUATION_ERROR:
			return {
				...state,
				updateequipment_evaluationError: action.payload,
				updateequipment_evaluationLoading: false,
			};
		case types.UPDATE_EQUIPMENT_EVALUATION_RESET:
			return {
				...state,
				updateequipment_evaluation: null,
				updateequipment_evaluationError: null,
				updateequipment_evaluationLoading: false,
			};
		//singleItem
		// case types.SINGLE_EQUIPMENT_EVALUATION_START:
		// 	return {
		// 		...state,
		// 		updateequipment_evaluation: null,
		// 		updateequipment_evaluationError: null,
		// 		updateequipment_evaluationLoading: true,
		// 	};
		// case types.SINGLE_EQUIPMENT_EVALUATION_SUCCESS:
		// 	return {
		// 		...state,
		// 		updateequipment_evaluation: action.payload,
		// 		updateequipment_evaluationLoading: false,
		// 	};
		// case types.SINGLE_EQUIPMENT_EVALUATION_ERROR:
		// 	return {
		// 		...state,
		// 		updateequipment_evaluationError: action.payload,
		// 		updateequipment_evaluationLoading: false,
		// 	};
		// case types.SINGLE_EQUIPMENT_EVALUATION_RESET:
		// 	return {
		// 		...state,
		// 		updateequipment_evaluationError: null,
		// 		updateequipment_evaluationLoading: false,
		// 	};

		default:
			return { ...state };
	}
};

export default EquipmentEvaluationReducer;
